import { render, staticRenderFns } from "./CreatePurchaseInvoice.vue?vue&type=template&id=1b92d018&scoped=true&"
import script from "./CreatePurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./CreatePurchaseInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchaseInvoice.vue?vue&type=style&index=0&id=1b92d018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92d018",
  null
  
)

export default component.exports